import { render } from "./TfaForm.vue?vue&type=template&id=25f40468"
import script from "./TfaForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./TfaForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script